module.exports = __webpack_public_path__ + "assets/images/flag-it-6752f5de6bc5386fc45ddb57bbb5af62.png";